import React from 'react';
import classnames from 'classnames';
import s from './Overlay.scss';
// TODO: refactor and work-into DeviationViews/Thumb/Standard/Overlay
export var Overlay = function (_a) {
    var className = _a.className, children = _a.children;
    return React.createElement("div", { className: classnames(s['root'], className) }, children);
};
Overlay.displayName = 'Overlay';
export default Overlay;
//# sourceMappingURL=Overlay.js.map